// lib/components/button/field-sub-button/field-sub-button.tsx
import classNames from "classnames";
import { jsx } from "@emotion/react/jsx-runtime";
var FieldSubButton = (props) => /* @__PURE__ */ jsx(
  "button",
  {
    ...props,
    className: classNames("button is-small", props.className),
    style: {
      fontSize: "0.8em",
      padding: "0.1em 0.5em",
      height: "24px",
      ...props.style
    }
  }
);

export {
  FieldSubButton
};
